import { Component, Output, EventEmitter, Inject, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { NotificationAddRecipientService } from '../notification-add-recipients-template/notification-add-recipients-template.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { ImportDialogFileComponent } from '../../create-notification/recipientslist/import-dialog-file/import-dialog-file.component';
import { RexisSapDialogComponent } from '../../rexis-sap-dialog/rexis-sap-dialog.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'dl-notification-add-recipients-template-dialog',
  templateUrl: './notification-add-recipients-template-dialog.component.html',
  styleUrls: ['./notification-add-recipients-template-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationAddRecipientsTemplateDialogComponent implements OnInit {
  @ViewChild('EmptyContactTemplate') recipientTemplate: TemplateRef<any>;
  public emptyContactList: any;
  public notificationData: any;
  public fileData = [];
  public columnData: any;
  public templateColumn: any;
  public templateData: any;
  public newFeedbackOption: Subject<any> = new Subject<any>();
  public isSendNotificationDisabled = true;
  public isDeleteDisabled = true;
  public isNtBtnDisabled = false;
  public isNewFromTemplate = true;
  public selectedRow = [];
  public isAddRecipientBtnExpanded:boolean = false;
  public isAddRecipientBtnDisabled:boolean = false;
  arrayBuffer: any;
  isDeleteDisabledCheck_dialog:Subject<any> = new Subject<any>();
  public dialogRefEmpty: any;
  public contactList: any;
  public isLimit = false;
  public contactLimitNumber: number = 5000;
  public isWarn: boolean = false;
  public isLimitDis: boolean = true;
  public isWarnDis: boolean = true;
  public excessList: number = 0;

  public constructor( 
    private qnSbnService:QnSbnService,
    private readonly dialog: MatDialog,
    public dialogRef: MatDialogRef<NotificationAddRecipientsTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _addRecipientTempService:NotificationAddRecipientService,
    private readonly oneSnackBar?: OneSnackBarService
  ) {}

  public ngOnInit(): void {
    this.notificationData = this.data.notificationData;
    this.templateColumn = this.data.columnData;
    this.templateData = this.data.tableData;
    this.contactList = this.data.contactList;
  }

  public newTemplateClicked(): void {
    this.isNtBtnDisabled = true;
    this.newFeedbackOption.next("Manual");

    const totalList = [...this.contactList, ...this._addRecipientTempService.list];
    if(totalList.length <= this.contactLimitNumber){
      this.isLimit = false;
      this.isLimitDis = false;
    }else{
      this.isLimit = true;
      this.isLimitDis = true;
      this.excessList = totalList.length - this.contactLimitNumber;
    }

    const duplicates = this.findDuplicates(this.contactList, this._addRecipientTempService.list);
    if(duplicates.length > 0){
      this.isWarn = true;
      this.isWarnDis = true;
    }else{
      this.isWarn = false;
      this.isWarnDis = false;
    }
  }

  public feedbackOptionAdded(isAdded: boolean): void {
    this.isAddRecipientBtnDisabled = !isAdded['isOptAdded'];
  }

  public getSelectedRowInTemplate(rows: any): void {
    this.isDeleteDisabled = rows['rowSelected'];
    // this.isSendNotificationDisabled = rows['rowSelected'];
  }

  public getTableData(data: any): void {
    this.isSendNotificationDisabled = this._addRecipientTempService.list.length < 1;

    const totalList = [...this.contactList, ...this._addRecipientTempService.list];
    if(totalList.length <= this.contactLimitNumber){
      this.isLimit = false;
      this.isLimitDis = false;
    }else{
      this.isLimit = true;
      this.isLimitDis = true;
      this.excessList = totalList.length - this.contactLimitNumber;
    }

    const duplicates = this.findDuplicates(this.contactList, this._addRecipientTempService.list);
    if(duplicates.length > 0){
      this.isWarn = true;
      this.isWarnDis = true;
    }else{
      this.isWarn = false;
      this.isWarnDis = false;
    }
    
  }

  public cancelClicked(){
    this._addRecipientTempService.changeUpdate(0,[]);
  }

  public sendNotificationCall(){
    let newRecipientData = this._addRecipientTempService.addRecipientsList(this.notificationData);
    this.qnSbnService.addNewRecipientList(newRecipientData).subscribe(dt=>{
      // console.log('Successfully Add Recipient Record :-->',dt);
      this.qnSbnService.getNotificationContactDetails(this.notificationData.NotificationId).subscribe(
        (newData:any) => {
          this.qnSbnService.getAccountList(this.notificationData.NotificationId).subscribe(
            (res: any) =>{
              this._addRecipientTempService.list.length = 0;
              this._addRecipientTempService.list$.next(this._addRecipientTempService.list);
              this.dialogRef.close({ data: newData, accData: res.body });
              this.oneSnackBar.open('Recipient added successfully.', OneSnackBarType.SUCCESS, '', { duration: 3000 });
            },
            (err: HttpErrorResponse) => {
              this.qnSbnService.httpErrorHandler(err, 'Could not fetch Account Data');
            }
          );
        },
        (error: HttpErrorResponse) => {
          // console.log('error:',error);
          this.qnSbnService.httpErrorHandler(error, 'Could not add recipients.');
        }
      );
    })
  }

  manualAddRecipientClicked(){
    this.isAddRecipientBtnExpanded = false;
    this.isAddRecipientBtnDisabled = true;
    this.newTemplateClicked();
  }
  contactListImportClicked(){
    this.isAddRecipientBtnExpanded = false;
    const dialogRef = this.dialog.open(ImportDialogFileComponent, {
      data: { fileData: this.fileData, columnData: this.columnData },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.fileData = result.fileData;
      this.columnData = result.columnData;

      this.emptyContactList = this.validateContactList(this.fileData);
      if (this.emptyContactList.emptyDataRow && this.emptyContactList.emptyDataRow.length > 0) {
        this.dialogRefEmpty = this.dialog.open(this.recipientTemplate, {
          data: { source: this.emptyContactList },
          disableClose: true
        });
        this.dialogRefEmpty.afterClosed().subscribe(result => {
          return;
        });
        return;
      }

      if(this.fileData != undefined){
        const jsData = this.fileData.map(data => {
          return {
            customerId: data[this.columnData.Customer_ID],
            customerName: data[this.columnData.Customer_name],
            customerContactName: data[this.columnData.Customer_contact_name],
            customerEmail: data[this.columnData.Customer_contact_email],
            sourceName: result.sourceName
          };
        })
        this.newFeedbackOption.next(jsData);
      }
    });
  }

  public validateContactList(contactList: any) {
    let invalidRecordIndex = [];
    let customEmptyData = [];
    const emptyRecords = contactList.filter((item, i) => {
      if (!item[this.columnData.Customer_contact_email] || 
      item[this.columnData.Customer_contact_email].trim() === '') {
        customEmptyData.push(
          {
            rowIndex: i+1,
            customerId: item[this.columnData.Customer_ID] || '',
            customerName: item[this.columnData.Customer_name] || '',
            customerContactName: item[this.columnData.Customer_contact_name] || ''
          }
        );
        return item;
      };
    });
    const invalidData = {
      emptyData: emptyRecords,
      emptyDataRow: customEmptyData
    };
    return invalidData;
  }

  public closeEmptyAlertDialog() {
    this.dialogRefEmpty.close();
  }

  addRecipientClicked(){
    this.isAddRecipientBtnExpanded = !this.isAddRecipientBtnExpanded;
  }

  deleteRows(){
    this.isDeleteDisabledCheck_dialog.next('deleteClicked');
    this.isSendNotificationDisabled = this._addRecipientTempService.list.length < 1;

    const totalList = [...this.contactList, ...this._addRecipientTempService.list]
    if(totalList.length <= this.contactLimitNumber){
      this.isLimit = false;
      this.isLimitDis = false;
    }else{
      this.isLimit = true;
      this.isLimitDis = true;
      this.excessList = totalList.length - this.contactLimitNumber;
    }

    const duplicates = this.findDuplicates(this.contactList, this._addRecipientTempService.list);
    if(duplicates.length > 0){
      this.isWarn = true;
      this.isWarnDis = true;
    }else{
      this.isWarn = false;
      this.isWarnDis = false;
    }
  }

  public findDuplicates(array1, array2) {
    const duplicates = [];
    const foundDuplicates = new Set();

    // Helper function to add to duplicates if not already added
    function addIfNotDuplicate(obj) {
        const objString = JSON.stringify(obj);
        if (!foundDuplicates.has(objString)) {
            duplicates.push(obj);
            foundDuplicates.add(objString);
        }
    }

    // Condition 1 and 2 between array1 and array2
    array1.forEach(obj1 => {
        array2.forEach(obj2 => {
            if (obj1.CustomerId === obj2.customerID) {
                if (obj1.CustomerContactEmail === obj2.customerContactEmail) {
                    addIfNotDuplicate(obj2);
                } else if (obj1.CustomerName !== obj2.customerName) {
                    addIfNotDuplicate(obj2);
                }
            }
        });
    });

    // Condition 1 and 2 within array2 itself
    array2.forEach((obj2, index2) => {
        array2.slice(index2 + 1).forEach(obj2Compare => {
            if (obj2.customerID === obj2Compare.customerID) {
                if (obj2.customerContactEmail === obj2Compare.customerContactEmail) {
                    addIfNotDuplicate(obj2Compare);
                } else if (obj2.customerName !== obj2Compare.customerName) {
                    addIfNotDuplicate(obj2Compare);
                }
            }
        });
    });

    return duplicates;
  }

  public contactListFromRexisSap(){
    this.isAddRecipientBtnExpanded = false;

    const dialogRef = this.dialog.open(RexisSapDialogComponent,{
      data: {Country: this.notificationData.Country},
      disableClose: true,
      autoFocus: true,
      panelClass: 'rexisPopup'
    });

    dialogRef.afterClosed().subscribe(resData => {
      const rexSapDataSelected = resData;
      if(rexSapDataSelected && rexSapDataSelected !== 'cancel'){
        const jsData = rexSapDataSelected.map(data => {
          return {
            customerId: data.erpAccountNo,
            customerName: data.accountName || data.name,
            customerContactName: data.contactName,
            customerEmail: data.contactEmail,
            sourceName: 'Rexis/SAP'
          };
        });
        this.newFeedbackOption.next(jsData);
      }else if(rexSapDataSelected === 'cancel'){
        console.log('cancel');
      }else {
        this.oneSnackBar.open('There is some problem with recipient list', OneSnackBarType.ERROR);
      }
    });
  }
}
